import React from 'react';
import { useMemo } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { useTranslation } from '@herob191/gatsby-plugin-react-i18next';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/16/solid';

export const figureRegular = (props) => {
  return <figure className="not-prose figure-regular">{props.children}</figure>;
};

export const figureExtraWide = (props) => {
  return (
    <div className="relative mt-12 has-[+_h1:not(:first-of-type)]:mb-18">
      <div className="figure-background absolute -left-[40%] hidden h-full w-28 bg-white xl:block"></div>
      <figure className="not-prose figure-extra-wide">{props.children}</figure>
    </div>
  );
};

export const figureLeftAligned = (props) => {
  return (
    <div className="not-prose figure-left-aligned-out">
      <figure>{props.children}</figure>
    </div>
  );
};

export const figureFullWidth = (props) => {
  return (
    <div className="figure-full-width-container">
      <figure className="not-prose figure-full-width">{props.children}</figure>
    </div>
  );
};

export const dividerThreeDots = () => {
  return <div className="divider-three-dots">* * *</div>;
};

export const dividerParaWideLine = () => {
  return <div className="divider-para-wide-line"></div>;
};

export const dividerFigureRegular = () => {
  return <div className="divider-figure-regular">* * *</div>;
};

export const chartDesktopRegular = (props) => {
  return (
    <figure className="figure-chart not-prose not-prose figure-regular hidden md:block">
      {props.children}
    </figure>
  );
};

export const chartDesktopExtraWide = (props) => {
  return (
    <div className="relative hidden md:block">
      <div className="not-prose figure-background absolute -left-[40%] hidden h-full w-28 bg-white xl:block"></div>
      <figure className="figure-chart not-prose figure-extra-wide">
        {props.children}
      </figure>
    </div>
  );
};

export const chartDesktopLeftAligned = (props) => {
  return (
    <figure className="not-prose figure-left-aligned-out hidden md:block">
      {props.children}
    </figure>
  );
};

export const chartDesktopFullWidth = (props) => {
  return (
    <div className="figure-full-width-container hidden md:block">
      <figure className="figure-chart not-prose figure-full-width">
        {props.children}
      </figure>
    </div>
  );
};

export const chartMobile = (props) => {
  return (
    <figure className="figure-chart not-prose figure-regular block md:hidden">
      {props.children}
    </figure>
  );
};

export const caseStudy = (props) => {
  return (
    <div className="case-study border-l-gecko-red border-2 border-stone-300 bg-stone-200 px-5 py-3">
      {props.children}
    </div>
  );
};

export const KeyFindings = (props) => {
  const { t } = useTranslation();

  return (
    <div className="key-findings border-gecko-red marker:bg-gecko-red relative mt-9 border-2 p-4 px-5 py-3 pt-14 font-sans leading-normal">
      <div className="absolute top-2 left-2 inline-block bg-black p-2 font-sans text-2xl text-white uppercase lg:left-[-2rem]">
        {t('common:article.keyFindings')}
      </div>
      {props.children}
    </div>
  );
};

export const videoRegular = (props) => {
  return (
    <video
      autoplay="true"
      playsInline
      muted
      loop
      className="not-prose figure-regular"
    >
      <source src={props.children} type="video/mp4" />
    </video>
  );
};

export const videoExtraWide = (props) => {
  return (
    <div className="not-prose figure-extra-wide">
      <video
        autoplay="true"
        muted
        loop
        playsInline
        className="h-full object-cover"
      >
        <source src={props.children} type="video/mp4" />
      </video>
    </div>
  );
};

export const videoLeftAligned = (props) => {
  return (
    <video
      autoplay="true"
      muted
      loop
      playsInline
      className="not-prose figure-left-aligned-out"
    >
      <source src={props.children} type="video/mp4" />
    </video>
  );
};

export const videoFullWidth = (props) => {
  return (
    <div className="figure-full-width-container">
      <video
        autoplay="true"
        muted
        loop
        playsInline
        className="figure-full-width no-prose object-cover"
      >
        <source src={props.children} type="video/mp4" />
      </video>
    </div>
  );
};

export const footnote = (props) => {
  // const uniqueIdentifier = crypto.randomUUID().toString();
  const uniqueIdentifier = Math.random();
  return (
    <aside className="inline">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */}
      <label
        aria-describedby="footnote"
        className="cursor-pointer px-1 align-top text-sm"
        htmlFor={uniqueIdentifier}
      ></label>
      <input
        id={uniqueIdentifier}
        className="margin-toggle hidden"
        type="checkbox"
      ></input>
      <span className="footnote float-none m-0 hidden w-11/12 py-2 pl-4 text-sm leading-5 text-stone-500">
        {props.children}
      </span>
    </aside>
  );
};

export const RelatedArticle = (props) => {
  const { t } = useTranslation();
  let slugArray = props.children.props.children.split('/');
  slugArray = slugArray.filter((empty) => empty);
  slugArray[slugArray.length - 3] === 'id'
    ? (slugArray = slugArray.slice(-3))
    : (slugArray = slugArray.slice(-2));

  // let relatedArticleSlug = `/${slugArray[0]}/${slugArray[1]}/`;
  let relatedArticleSlug = `/${slugArray.join('/')}/`;

  console.log(relatedArticleSlug);
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      allMarkdownRemark {
        nodes {
          frontmatter {
            title
            description
            main_topic
            featuredimage {
              childImageSharp {
                gatsbyImageData(
                  width: 600
                  height: 400
                  quality: 50
                  layout: CONSTRAINED
                )
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }
  `);

  const thisArticle = useMemo(
    () =>
      data.allMarkdownRemark.nodes.find(
        (node) => relatedArticleSlug === node.fields.slug
      ),
    [data, relatedArticleSlug]
  );

  return (
    <div className="related-article-container float-left mr-5 mb-2 w-1/3 p-0 pt-2">
      <a
        href={thisArticle.fields.slug}
        target="_blank"
        rel="noopener noreferrer"
        className="group block no-underline"
      >
        <GatsbyImage
          image={getImage(thisArticle.frontmatter.featuredimage)}
          className="rounded-sm brightness-90 transition group-hover:brightness-95"
        />
        <h3 className="my-2 text-lg leading-none text-slate-600">
          {thisArticle.frontmatter.title}
        </h3>

        <p className="mb-0 pt-0 text-sm font-light text-stone-500">
          {thisArticle.frontmatter.description}
        </p>
        <div className="group border-gecko-red text-gecko-red mt-3 flex justify-start border-t-2 pt-1 font-sans text-sm">
          <span className="block uppercase">
            {t('common:article.readMore')}
          </span>
          <ArrowTopRightOnSquareIcon className="ml-2 inline h-4 w-4 transition-all group-hover:translate-x-1 group-hover:transition-all" />
        </div>
      </a>
    </div>
  );
};
